module.exports = __webpack_public_path__ + "static/media/favicon.221ac120.ico";